module.exports = __webpack_public_path__ + "img/searching.712d9f74.svg";